// @flow

const getInitialsFromString = (str: string): string[] => {
  return str.split(/\s+/).map(s => s[0]);
};

export default getInitialsFromString;
